import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  paper: { maxHeight: 360 },
});

export default useSx;
